import { createAction, createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { ToggleMuteActionInterface } from '../../types';

type DeviceState = {
    audioIsTemporarilyUnMuted: boolean;
    microphoneDevicePermission?: PermissionState;
    cameraDevicePermission?: PermissionState;
};

const initialState: DeviceState = {
    audioIsTemporarilyUnMuted: false,
};

const deviceSlice = createSlice({
    name: 'device',
    initialState,
    reducers: {
        setAudioIsTemporarilyUnMuted(state, action: PayloadAction<boolean>) {
            state.audioIsTemporarilyUnMuted = action.payload;
        },
        setMicrophonePermission(state, action: PayloadAction<PermissionState>) {
            state.microphoneDevicePermission = action.payload;
        },
        setCameraPermission(state, action: PayloadAction<PermissionState>) {
            state.cameraDevicePermission = action.payload;
        },
        resetDeviceState(state) {
            const { cameraDevicePermission, microphoneDevicePermission } = state;
            return { cameraDevicePermission, microphoneDevicePermission, ...initialState };
        },
    },
});
export const toggleMuteAction = createAction<ToggleMuteActionInterface>('conference/device/toggleMute');
export const { setAudioIsTemporarilyUnMuted, resetDeviceState, setMicrophonePermission, setCameraPermission } =
    deviceSlice.actions;
export const deviceReducer = deviceSlice.reducer;
